export const environment = {
  production: false,
  env: 'qx',
  apiHost: 'https://api.qa.muni-np.spglobal.com',
  muniApiHost: 'https://api.staging.muni.ipreo.com',
  dealUpdateChannel: 'casa-muni-deal-updates-qx',
  appName: 'muni-gameday-direct-qx',

  polaris: {
    env: 'staging',
    registryUrl: 'https://registry.staging.browsermodules.ihsmarkit.com',
    apiBaseUrl: 'https://api.staging.polaris.ihsmarkit.com',
    wsUrl: 'wss://gateway.staging.sockets.ipreo.com/connect',
    logInterval: 30000
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/dist/zone-error'; // Included with Angular CLI.
